export default __webpack_public_path__ + "static/bunfestival-map-5abf3e00f1cba2e62a742d60c3c2491b.png";